// src/components/pwa/UpdateAvailableBanner.jsx
import React, { useEffect, useState } from 'react';

// Standalone (no context dependency) so it works under both the admin and
// client route trees. Listens for the 'sw-update-available' event dispatched
// from src/index.js when serviceWorkerRegistration reports a waiting worker.
const UpdateAvailableBanner = () => {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handleUpdate = (event) => setRegistration(event.detail);
    window.addEventListener('sw-update-available', handleUpdate);
    return () => window.removeEventListener('sw-update-available', handleUpdate);
  }, []);

  useEffect(() => {
    if (!registration) return;

    const handleControllerChange = () => window.location.reload();
    navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    return () =>
      navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
  }, [registration]);

  if (!registration) return null;

  const handleRefresh = () => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  return (
    <div
      role="alert"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-2xl border-l-4 border-amber-500 bg-amber-50 text-amber-900 shadow-lg px-4 py-3"
    >
      <span className="text-sm font-medium">A new version of Zimzo is available.</span>
      <button
        onClick={handleRefresh}
        className="text-sm font-semibold text-amber-900 underline hover:no-underline"
      >
        Refresh
      </button>
    </div>
  );
};

export default UpdateAvailableBanner;
